import {v4 as uuidv4} from 'uuid'

export abstract class Command {
    constructor() {
        this.id = uuidv4()
    }
    id: string
}